import React from 'react';
import { Form, Icon, Message } from 'semantic-ui-react'
import _find from 'lodash/find';
import { List } from 'semantic-ui-react'
import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';
import queries from '../../../utils/queries'
import general from '../../../modulos/general';

import EstaSeg7Btn from '../../../components/funcionales/estaseg7btn';
import EstaSeguro from '../../../components/funcionales/estaseguro'

const DetalleNivelLista = ({elementoI, handleClickidListaI, idListaI}) => {
  return(
    <tr className='' onClick={(ev)=>handleClickidListaI(ev, elementoI)}>
      <td className='center aligned' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12,
              color: 'black', background: '#white'}}>{elementoI.cantidadAprob}</td>
      <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12,
              color: 'black', background: '#white'}}>{elementoI.descrUnidad}</td>
      <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12,
              color: 'black', background: '#white'}}>{elementoI.descrProducto}</td>
      {/* <td className='right aligned' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12,
              color: 'black', background: '#white'}}>{new Intl.NumberFormat('de-DE').format(elementoI.valorUniAprob)}</td>
      <td className='center aligned' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12,
              color: 'black', background: '#white'}}>{elementoI.porcDcto}</td>
      <td className='center aligned' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12,
              color: 'black', background: '#white'}}>{elementoI.porcIncremento}</td>
      <td className='right aligned' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12,
              color: 'black', background: '#white'}}>{new Intl.NumberFormat('de-DE').format((elementoI.cantidadAprob * (elementoI.valorUniAprob * (1 - (elementoI.porcDcto/100)) * (1 + (elementoI.porcIncremento/100)))))}</td>
      <td className='center aligned' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12,
              color: 'black', background: '#white'}}>{elementoI.porcIVA}</td> */}
    </tr>
  )
};
const Lista = ({listI, handleClickidListaI, idListaI}) => {
  const nivel1Detalle = listI.map((elementoI, i) => <DetalleNivelLista elementoI={elementoI} handleClickidListaI={handleClickidListaI} idListaI={idListaI}
        key={i}/>);
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
}; 

const DetalleOpeNivel1 = props => {
  return (
    <option dato1={props.elemento.cedula} value={props.elemento.nombreUsuario}>{props.elemento.nombreUsuario}</option>
  )
};

const ListaOpe = ({list, idLista, argsDocum, permiteUpdate, handleChange}) => {
  const Nivel4Detalle = list.map((elemento, _id) => <DetalleOpeNivel1 elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="nombreUsuarioOC" id="miLista1" value={permiteUpdate?argsDocum.nombreUsuarioOC:idLista.nombreUsuarioOC} onChange={(ev)=>handleChange(ev, argsDocum)}>
        {/* <option value="">Seleccionar...</option> */}
        {Nivel4Detalle}
      </select>
    </div>
  )
};
// const ListaSN = ({nameLista, idLista, argsDocum, permiteUpdate, handleChange}) => {
//   return(
//     <div>
//       <select className="ui simple selection dropdown fluid" name={nameLista} id={nameLista} value={permiteUpdate?argsDocum[nameLista]:idLista[nameLista]?idLista[nameLista]:"Seleccionar..."} onChange={(ev)=>handleChange(ev)}>
//         <option>Seleccionar...</option>
//         <option>No</option>
//         <option>Si</option>
//       </select>
//     </div>
//   )
// };

class VerOrdenCompra2 extends React.Component {   
   
  state={
    argsDocum: {
      estadoOC: this.props.idLista.estadoOC,
      descrEmpresa: this.props.idLista.descrEmpresa,
      observacionesOC: this.props.idLista.observacionesOC?this.props.idLista.observacionesOC:"",
      observacionesAutOC: this.props.idLista.observacionesAutOC?this.props.idLista.observacionesAutOC:"",
      cedulaOC: this.props.idLista.cedulaOC,
      numOrdenCompra: this.props.idLista.numOrdenCompra,
      nombreUsuarioOC: this.props.idLista.nombreUsuarioOC?this.props.idLista.nombreUsuarioOC:'',
      fechaIni: this.props.idLista.fechaIni?this.props.idLista.fechaIni:this.props.fechaHoy,
      fechaFin: this.props.idLista.fechaFin?this.props.idLista.fechaFin:this.props.fechaFin,
      usuarioIni: this.props.idLista.usuarioIni?this.props.idLista.usuarioIni:"",
      // zonaFranca: this.props.idLista.zonaFranca?this.props.idLista.zonaFranca:"",
      // gestionIngreso: this.props.idLista.gestionIngreso?this.props.idLista.gestionIngreso:"",
      _id: this.props.idLista._id,
    },
    confirmaAct: false, descrProductoI: "", permiteBtn1: true, procBtn: 0, checked: false, 
    open: false, list5: [],
    argsQuery1: `{$match: {tipoCoti: 'Cliente'}}, 
    {"$unwind": "$itemsCoti"},
    {$project: {numOrdenCompra: {"$toString": "$numOrdenCompra"}, 
        descrProducto: '$itemsCoti.descrProducto', 
        cantidadAprob: '$itemsCoti.cantidadAprob', 
        valorUniAprob: '$itemsCoti.valorUniAprob', 
        porcDcto: '$itemsCoti.porcDcto',
        porcIncremento: '$itemsCoti.porcIncremento',
        porcIVA: '$itemsCoti.porcIVA',
        descrUnidad: '$itemsCoti.descrUnidad'}},
    {$project: {_id: {$concat: ['$numOrdenCompra', '$descrProducto']}, 
        numOrdenCompra: 1,descrProducto: 1, cantidadAprob: 1, valorUniAprob: 1, porcIVA: 1, porcDcto: 1, porcIncremento: 1, descrUnidad: 1}},
    {$sort: {descrProducto: 1}}`
  }

  handleChange = (ev, argsDocum) => {
    if (this.props.permiteUpdate){
      this.setState({confirmaAct: false})
      const argsDocum = this.state.argsDocum
      if(ev.target.name==="aprobarOC"){
        this.setState({checked: ev.target.checked})
      } 
      if(ev.target.name === "nombreUsuario"){
          let miLista = document.getElementById("miLista1");
          argsDocum['nombreUsuario'] = miLista.options[miLista.selectedIndex].text
          argsDocum['cedula'] = miLista.options[miLista.selectedIndex].attributes[0].value
      }else{
        if(ev.target.name === "descrEmpresa"){
          let miLista = document.getElementById("miLista");
          argsDocum['descrEmpresa'] = miLista.options[miLista.selectedIndex].text
        }else{
          argsDocum[ev.target.name] = ev.target.value
        }
      }
      console.log(argsDocum)
      this.setState({argsDocum});
    }
  }

  handleClickidListaI = async (ev, idLista, productoI)=>{
    ev.preventDefault()
    this.setState({descrProductoI: productoI})
  }

  handleQuestionUpdDel = async (ev, btn) => {
    var btnPress = await ev.target.attributes[0].value
    if(btnPress==="btnUpdDel" && !this.state.confirmaAct && this.state.procBtn===0){
      this.setState({open: true})
      this.setState({permiteBtn1: btn==="1"?true:false, permiteBtn2: btn==="2"?true:false})
    }else{
      this.setState({open: false})
      this.setState({procBtn: 0})
      this.setState({permiteBtn1: true, permiteBtn2: true})
    };
    if(btnPress==="No"){
      this.setState({open: false})
      this.setState({procBtn: 0})
      this.setState({permiteBtn1: true, permiteBtn2: true})
    };
    if(btnPress==="Si"){
      this.setState({confirmaAct: true})
      this.setState({open: false})
      this.setState({procBtn: 1})
      this.setState({permiteBtn1: btn==="1"?true:false, permiteBtn2: btn==="2"?true:false})
      const myBtn = document.getElementById("btnUpdDel");
      myBtn.click()
    }
  }

  handleElimItem = async (ev, descrProductoI, idOrden, numOrdenCompra)=>{
    if(descrProductoI){
      const argsUpd = {
        descrProducto: descrProductoI,
        _id: idOrden
      }
      argsUpd.tipoAct = "EliminarItem"
      await this.props.editCotizacion({variables: argsUpd});
      let argsBuscar=""
      argsBuscar += `numOrdenCompra: '${numOrdenCompra}'`
      let argsBuscarIt = {}
      argsBuscarIt = {tipoqry: `[${this.state.argsQuery1}, {$match: {${argsBuscar}}}]`}
      let {data} = await this.props.allCotizacionRtes00.refetch(argsBuscarIt)
      this.setState({list5: await data.allCotizacionRtes})    
    }else{
      alert("!! Por favor seleccione el producto !!")
    }
  }

  render (){ 
    const {checked, argsDocum, confirmaAct, open, productoI, permiteBtn1, list5} = this.state;
    const a3540 = this.props.autorizacUA.findIndex( autorizac => autorizac === "3540" );
    const a354005 = this.props.autorizacUA.findIndex( autorizac => autorizac === "354005" );
    const a354007 = this.props.autorizacUA.findIndex( autorizac => autorizac === "354007" );

    let lista5 = []
    if(list5.length>0){
      lista5 = list5
    }else{    
      if(this.props.list5){
        lista5 = this.props.list5
      }
    }

    if(checked===true){
      argsDocum.estadoOC = "Aprobada"
    }else{
      argsDocum.estadoOC = "Creada"
    }
    let mensaje1 = ""
    if(this.props.productoI){
      mensaje1 = `Eliminar ${this.props.productoI} de la orden de compra ${argsDocum.numOrdenCompra}`
    }else{
      mensaje1 += "(Seleccionar...)"
    }
    let imgIcon1 = "images/archivo_32.png"
    let mensajeCan = "CANCELAR EJECUCION DE OC No. " + this.props.idLista.numOrdenCompra

    let descrEmpresaAnt = this.props.idLista.descrEmpresa
    let tipoAnt = this.props.idLista.tipo
    let _id = this.props.idLista._id
    let numOrdenCompra = this.props.idLista.numOrdenCompra

    let fechaIni = new Date(argsDocum.fechaIni)
    fechaIni = (fechaIni.getFullYear()) + '-' + ((fechaIni.getMonth()+1)<10?'0'+(fechaIni.getMonth()+1):(fechaIni.getMonth()+1)) + '-' + (fechaIni.getUTCDate()<10?'0'+fechaIni.getUTCDate():fechaIni.getUTCDate())
  
    let fechaFin = new Date(argsDocum.fechaFin)
    fechaFin = (fechaFin.getFullYear()) + '-' + ((fechaFin.getMonth()+1)<10?'0'+(fechaFin.getMonth()+1):(fechaFin.getMonth()+1)) + '-' + (fechaFin.getUTCDate()<10?'0'+fechaFin.getUTCDate():fechaFin.getUTCDate())
    let controlElimI = "S"
    
    if(this.props.permiteUpdate || this.props.permiteDelete || !this.props.productoI){
      controlElimI = "N"
    }

    let listOpe=[], list1=[], listPerf=[]
    list1=this.props.list1
    console.log(list1)
    listPerf=this.props.list2
    const elemento3 = list1
    elemento3.forEach((elemento, i) => {
      let indexPerf = listPerf.findIndex( perfiles => perfiles.descrPerfil===elemento.perfil.descrPerfil)
      if(indexPerf!==-1){
        listOpe.push({nombreUsuario: elemento.nombreUsuario, 
          cedula: elemento.cedula
        });
      }
    })

    return(
      <div> 
        <button className="ui right labeled icon button" style={this.props.styles.titBuscar}>
          <i className="large hand point down yellow icon"></i>
          Ordenes de compra
        </button>
        <div style={this.props.styles.box}>
          <Form name="form1" id="form1" onSubmit={confirmaAct?
            (ev)=>this.props.handleSubmit(ev, argsDocum, descrEmpresaAnt, tipoAnt):
            // permiteBtn1? 
            // (ev)=>this.handleElimItem(ev, this.props.productoI, _id, numOrdenCompra):
            ()=>{}}
          >

            <div className="ui two column stackable grid">
              <div className="row container">
                 <div className="column" width="50%">                
                  {a354007!==-1 &&
                    <Form.Field>
                      <label style={this.props.styles.label}>Coordinador</label>
                      <ListaOpe list={listOpe} styles={this.props.styles} idLista={this.props.idLista} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                    </Form.Field>    
                  }
                  {a354007===-1 &&
                    <Form.Field>
                      <label style={this.props.styles.label}>Coordinador:</label>
                      <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.8em 0em 0em 0em'}}>
                        {this.props.idLista.nombreUsuarioOC?this.props.idLista.nombreUsuarioOC:''}
                      </p>
                    </Form.Field>
                  }
                </div>
                {/* <div className="column" width="50%">
                  <Form.Field>
                    <label style={this.props.styles.label}>Empresa</label>
                    <ListaEmp list={this.props.list} styles={this.props.styles} idLista={this.props.idLista} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                  </Form.Field>
                </div> */}
                <div className="column" width="50%">
                  <Form.Field>
                    <label style={this.props.styles.label}>Empresa:</label>
                    <p style={{color: '#302b63', fontSize: '1.2em', fontWeight: 'bold', margin: '0.8em 0em 0em 0em'}}>
                      {this.props.idLista.descrEmpresa}
                    </p>
                  </Form.Field>
                </div>
              </div>
              <div className="row container">
                <div className="column" style={{width: '20%'}}>
                  <label style={this.props.styles.label}>Fecha de inicio:</label>
                  <Form.Field>
                    <input style={this.props.styles} type='date' name="fechaIni" id="fechaIni" value={fechaIni} onChange={this.handleChange}/>
                  </Form.Field>
                </div>
                <div className="column" style={{width: '20%'}}>
                  <label style={this.props.styles.label}>Fecha de entrega:</label>
                  <Form.Field>
                    <input style={this.props.styles} type='date' name="fechaFin" id="fechaFin" value={fechaFin} onChange={this.handleChange}/>
                  </Form.Field>
                </div>
                {/* <div className="column" style={{width: '20%'}}>
                  <label style={this.props.styles.label}>Entrega en zona franca</label>
                  <Form.Field>
                    <ListaSN styles={this.props.styles} nameLista='zonaFranca' idLista={this.props.idLista} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                  </Form.Field>
                </div>
                <div className="column" style={{width: '20%'}}>
                  <label style={this.props.styles.label}>Gestionar ingreso</label>
                  <Form.Field>
                    <ListaSN styles={this.props.styles} nameLista='gestionIngreso' idLista={this.props.idLista} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                  </Form.Field>
                </div>   */}
              </div>            
            </div>
            <div className="row container">
              <div className="column" width="100%">  
                <Form.Field>
                  <label style={this.props.styles.label}>Observaciones</label>
                  <Form.Input autoComplete="off" name="observacionesOC" id="observacionesOC" value={argsDocum.observacionesOC} onChange={this.handleChange} placeholder='Observaciones' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'observacionesOC'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                </Form.Field> 
              </div>
            </div>
            {a3540!==-1 &&
              <div className="ui two column stackable grid">
                <div className="row container">
                  <div className="column" style={{width: '17%'}}>
                    <Form.Field>
                        <div className="column">
                          <input type='checkbox' id="aprobarOC" name="aprobarOC" style={this.props.styles.input} checked={checked} onChange={this.handleChange}/>
                          <label style={this.props.styles.label}>&nbsp;&nbsp;APROBAR INICIO</label>
                        </div>
                    </Form.Field>
                  </div>
                  <div className="column" style={{width: '83%'}}>  
                    <Form.Field>
                      <label style={this.props.styles.label}>Observaciones para aprobación</label>
                      <Form.Input autoComplete="off" name="observacionesAutOC" id="observacionesAutOC" value={argsDocum.observacionesAutOC} onChange={this.handleChange} placeholder='Observaciones de aprobación' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'observacionesAutOC'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                    </Form.Field>
                  </div>
                </div>
              </div> 
            }
            <div className="ui one column stackable grid">
              <div className="row container">
                <div className="column" width="100%">
                  <EstaSeguro permiteUpdate={this.props.permiteUpdate}  
                    permiteDelete={this.props.permiteDelete} 
                    open={open} styles={this.props.styles} 
                  handleQuestionUpdDel={(ev)=>this.handleQuestionUpdDel(ev, "2")}/>
                </div>
                {
                  this.props.errors.length?<Message negative header="Los siguientes errores:"
                  list={this.props.errors.map(error=>`${error.path}: ${error.message}`)} />:null
                }
              </div>
            </div>

              <div className="column" width="100%">
                <div style={{height: '15em', overflow: 'auto'}}>
                  <table className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                    <thead className=''>
                      <tr className=''>
                        <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '7%'}}>Cantidad</th>
                        <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '7%'}}>Unidad</th>
                        <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '48%'}}>Producto</th>
                        {/* <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '7%'}}>Valor unidad</th>
                        <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '7%'}}>% Dcto</th>
                        <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '7%'}}>% Incremento</th>
                        <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '10%'}}>Total producto</th>
                        <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '7%'}}>% IVA</th> */}
                      </tr>
                    </thead>
                    <Lista listI={lista5} handleClickidListaI={this.props.handleClickidListaI} productoI={productoI}/>
                  </table>
                  <p></p>
                </div>
              </div>

              {/* <div className="column" style={{width: '100%', paddingTop: '0.3em'}}>
                { controlElimI === "S" &&
                <EstaSeg7Btn mensaje1={mensaje1} imgIcon1={imgIcon1} 
                  open={open}
                  styles={this.props.styles} handleQuestionUpdDel={(ev)=>this.handleQuestionUpdDel(ev, "1")}/>
                }
              </div> */}
            
          </Form>
        </div>
      </div>
    )
  }
}

// export default VerCotizacion2
export default compose(
  // graphql(queries.query.allProducto, {name:'allProducto'}),
  graphql(queries.query.allEmpresa, {name:'allEmpresa'}),

  graphql(queries.query.allCotizacionRtes, {name:'allCotizacionRtes00',
    options: (props) => {return {variables: {tipoqry: `[{$match: {tipoCoti: 'Cliente', estadoOC: 'Creada'}}]`}}}}),

  graphql(queries.mutation.editCotizacion, {name:'editCotizacion'}),


)(VerOrdenCompra2)
